<template>
  <div class="record_container">
    <div class="info_tab" v-if="showPrint" data-html2canvas-ignore>
      <img @click="handleBack" style="width: 24px; height: 24px" src="../assets/back.png" />
      <div>查看原流程</div>
      <p style="float: right; margin-right: 10px" @click="wantWx">
        <img style="width: 18px; height: 18px" src="../assets/share.png" alt="" />
        <span class="zf">{{ !pdfLoading ? '转发' : '处理中...' }}</span>
      </p>
    </div>
    <div class="info_container">
      <div class="info_submit1">
        <span>{{ initiator.staffName }}提出的{{ modelName }}</span>
        <span v-if="makeCardTimes">本月第{{ makeCardTimes }}次补卡</span>
      </div>
      <div class="info_submit2" :style="{ color: color }">{{ statusMsg }}</div>
    </div>
    <div class="approve_company">
      <span class="info_field">所属公司:</span>
      <span class="info_text">{{ initiator.companyName }}</span>
    </div>
    <div class="approve_info" style="margin-top: 0.3rem">
      <div>
        <span class="info_field">审批编号:</span>
        <span class="info_text">{{ approvalNo }}</span>
      </div>
      <div v-for="(item, index) in formList" :key="index">
        <span class="info_field" v-if="item.fieldType !== 'upload'">{{ handleFieldName(item) }}:</span>
        <span v-if="item.fieldType !== 'textarea'" class="info_text">
          {{ renderItem(item) }}
        </span>
        <div v-if="item.fieldType === 'textarea'" v-text="renderTextArea(item)" class="info_text"></div>
      </div>
    </div>

    <div class="annex_box pdfItem" v-if="fileList.length > 0">
      <div style="font-size: 16px; line-height: 22px; margin-bottom: 10px; font-family: PingFangSC-Medium, PingFang SC; font-weight: 500; color: #333333">附件：</div>
      <div v-for="(item, index) in fileList" :key="index">
        <div style="display: flex; justify-content: space-between; align-items: center" v-for="(i, index1) in item.value" :key="index1">
          <div class="annex_name">
            <img style="width: 22px; height: 20px; margin-right: 8px" src="@/assets/file@2x.png" />
            <div style="display: flex; flex-direction: column">
              <div style="width: 5rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                {{ i ? i.name + i.suffix : '' }}
              </div>
              <div>{{ formatSize(i.size, 2) }}</div>
            </div>
          </div>
          <div class="annex_button" @click="preview(i.url)">预览</div>
          <div class="annex_button" @click="download(i)">下载</div>
        </div>
      </div>
    </div>
    <div class="annex_box" v-if="showApprovalFileList">
      <div style="font-size: 16px; line-height: 22px; margin-bottom: 10px; font-family: PingFangSC-Medium, PingFang SC; font-weight: 500; color: #333333">审批人附件：</div>
      <div v-for="(item, index) in links" :key="index">
        <div v-if="item.files.length > 0">{{ item.staffName }}</div>
        <div style="display: flex; justify-content: space-between; align-items: center" v-for="(i, index1) in item.files" :key="index1">
          <div class="annex_name">
            <img style="width: 22px; height: 20px; margin-right: 8px" src="@/assets/file@2x.png" />
            <div style="display: flex; flex-direction: column">
              <div style="width: 5rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                {{ i ? i.name + i.suffix : '' }}
              </div>
              <div>{{ formatSize(i.size, 2) }}</div>
            </div>
          </div>
          <div class="annex_button" @click="preview(i.url)">预览</div>
          <div class="annex_button" @click="download(i)">下载</div>
        </div>
      </div>
    </div>
    <div class="process_info pdfItem">
      <div style="font-size: 16px; line-height: 22px; margin-bottom: 10px; font-family: PingFangSC-Medium, PingFang SC; font-weight: 500; color: #333333">流程:</div>
      <div class="process_start">
        <div style="display: flex">
          <img v-if="initiator.avatar" :src="initiator.avatar" style="width: 40px; height: 40px; margin-right: 8px; border-radius: 0.21rem" />
          <img src="@/assets/default.png" class="member_img" v-else />
          <div style="display: flex; justify-content: space-between; width: 7rem">
            <div>
              <div style="color: #333333">发起申请</div>
              <div style="color: #333333; font-size: 12px">{{ initiator.staffName }}</div>
            </div>
            <div style="color: #999999">
              {{ initiator.createDate && initiator.createDate != '0' ? dayjs(Number(initiator.createDate)).format('YYYY-MM-DD HH:mm:ss') : '' }}
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div class="process_arrow">
            <div style="height: 1rem"></div>
            <div></div>
          </div>
        </div>
      </div>
      <div
        :class="{
          process_start: true,
          process_end: index === links.length - 1
        }"
        v-for="(item, index) in links"
        :key="index"
      >
        <div style="display: flex">
          <img v-if="item.avatar" :src="item.avatar" style="width: 40px; height: 40px; margin-right: 8px; border-radius: 0.21rem" />
          <img src="@/assets/default.png" class="member_img" v-else />
          <div>
            <div :style="handleTimeStyle(item)">
              <div v-if="item.userType === 'approver'" style="color: #333333; font-size: 14px">
                <div v-if="kitValue == 99">接收人</div>
                <div v-else>审批人</div>
              </div>
              <div v-else style="color: #333333">办理人</div>
              <div :style="handleStyle(item)" class="approve_status">
                {{ renderStatus(item) }}
              </div>
              <div style="color: #999999">
                {{ item.actionTime && item.actionTime != '0' ? dayjs(Number(item.actionTime)).format('YYYY-MM-DD HH:mm:ss') : '' }}
              </div>
            </div>

            <div>
              <span style="color: #666666; font-size: 12px">
                {{ renderMember(item) }}
              </span>
              <span style="color: #1584ff; font-szie: 12px; opacity: 0.5" v-if="item.currentPosition">({{ item.currentPosition }})</span>
            </div>
          </div>
        </div>
        <div style="display: flex">
          <div class="process_arrow" v-if="index < links.length - 1">
            <div></div>
            <div></div>
          </div>
          <div class="process_arrow" style="min-height: 0" v-if="index === links.length - 1"></div>
          <div :class="{ 'approve-content': item.content }">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div class="cclist pdfItem">
      <div style="font-size: 16px; line-height: 22px; margin-bottom: 10px; font-family: PingFangSC-Medium, PingFang SC; font-weight: 500; color: #333333">抄送人:</div>
      <div style="display: flex; flex-wrap: wrap">
        <div class="selected-member" v-for="(item, index) in copyLink.members" :key="index">
          <img v-if="item.avatar" class="member-img" :src="item.avatar" />

          <img src="@/assets/default.png" class="member-img" v-else />
          <div style="color: #333333; font-size: 12px">
            {{ item.staffName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getApplyInfo, getMakeCardTimes, upload } from '../axios/services';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { formatSize } from '../utils';
import htmlToPdf from '@/utils/htmlToPdf';

export default {
  components: {},
  data() {
    return {
      formList: [], // 流程表单信息
      links: [], // 流程审批信息
      initiator: {}, // 发起人信息
      currentApprover: {},
      finalStatus: '',
      statusMsg: '',
      copyLink: {},
      color: '',
      modelName: '',
      fileList: [],
      isAndroid: false,
      makeCardTimes: '',
      approvalNo: '',
      showApprovalFileList: false, // 是否展示审批人附件
      showPrint: true,
      pdfFile: null,
      pdfLoading: false,
      oldInstanceId: ''
    };
  },
  watch: {
    finalStatus(val) {
      this.color = val === 1 ? 'green' : val === 2 ? '#fe5208' : '#ffba18';
    }
  },

  methods: {
    print() {
      this.showPrint = false;
      console.log('执行打印');
      if (this.isAndroid) {
        window.androidPrint.print();
      } else {
        window.webkit.messageHandlers.iosPrint.postMessage('0');
      }
    },

    handleTimeStyle(item) {
      if (item.actionTime) {
        return {
          display: 'flex',
          'justify-content': 'space-between',
          width: '7rem'
        };
      } else {
        return {
          display: 'flex'
        };
      }
    },

    dayjs,
    formatSize(size, length) {
      return ''; // 不需要展示文件大小
      return formatSize(size, length);
    },

    handleStyle(item) {
      let str = '';
      switch (item.status) {
        case '0':
          str = 'color: #FFBA19;border: 1px solid #FFBA19';
          break;
        case '1':
          str = 'color: #00CA7B;border: 1px solid #00CA7B';
          break;
        case '' || '00':
          break;
        default:
          str = 'color: red;border: 1px solid red';
          break;
      }
      if (!item.actionTime) {
        str = str + ';margin-left: 0.7rem';
      }
      return str;
    },
    showFinalStatus() {
      switch (this.finalStatus) {
        case 0:
          if (this.kitValue == 99) {
            this.statusMsg = this.currentApprover?.staffName + '阅读中';
          } else {
            this.statusMsg = this.currentApprover?.staffName + '审核中';
          }
          break;
        case 1:
          if (this.kitValue == 99) {
            this.statusMsg = '已阅';
          } else {
            this.statusMsg = '通过';
          }
          break;
        case 2:
          this.statusMsg = '拒绝';
          break;
        case 3:
          this.statusMsg = '撤销';
          break;
        case 4:
          this.statusMsg = '被退回';
          break;
        default:
          break;
      }
    },
    renderStatus(item) {
      let status = '';
      switch (item.status) {
        case '0':
          if (this.kitValue == 99) {
            status = '未读';
          } else {
            status = '审核中';
          }
          break;
        case '1':
          if (this.kitValue == 99) {
            status = '已阅';
          } else {
            status = '通过';
          }
          break;
        case '2':
          status = '拒绝';
          break;
        case '3':
          status = '转交';
          break;
        case '4':
          status = '退回';
          break;
        case '5':
          status = '评论';
          break;
        case '7':
          status = '转交';
          break;
        default:
          break;
      }
      return status;
    },
    preview(param) {
      window.location.href = 'jsToOc://fujianJump?url=' + param;
    },
    download(item) {
      if (this.isAndroid) {
        window.attachmentDownload.downloadFile(item.url, item.name, item.suffix);
      } else {
        window.webkit.messageHandlers.attachmentDownload.postMessage({
          url: item.url,
          name: item.name,
          suffix: item.suffix
        });
      }
    },

    flatten(arr) {
      let res = [];
      arr.map(item => {
        if (Array.isArray(item)) {
          res = res.concat(this.flatten(item));
        } else {
          res.push(item);
        }
      });
      return res;
    },

    renderItem(item) {
      let str = '';

      if (item.fieldType === 'upload') {
        return str;
      }
      if (item.fieldType === 'dept') {
        item.value?.forEach(e => {
          str = str + e.name + '/';
        });
        return str.slice(0, str.length - 1);
      }
      if (item.fieldType === 'switch') {
        return item.value ? '是' : '否';
      }
      if (item.fieldType === 'map') {
        str = item.value.address;
        return str;
      }
      if (item.fieldType === 'mapList') {
        let arr = item.value.map(item => {
          return item.name;
        });
        str = arr.toString();
        return str;
      }
      if (item.fieldType === 'position') {
        item.value?.forEach(e => {
          str = str + e.name + '/';
        });
        str = str.slice(0, str.length - 1);
        return str;
      }
      if (item.fieldType === 'department') {
        item.value?.forEach(e => {
          str = str + e.officeName + '/';
        });
        str = str.slice(0, str.length - 1);
        return str;
      }
      if (item.fieldType === 'company') {
        item.value?.forEach(e => {
          str = str + e.name + '/';
        });
        str = str.slice(0, str.length - 1);
        return str;
      }
      if (item.fieldName == '时长') {
        str = item.value + '小时';
        return str;
      }
      if (item.fieldName == '请假天数') {
        str = item.value + '天';
        return str;
      }
      return item.value;
    },
    renderTextArea(item) {
      return item.value;
    },

    handleBack() {
      this.$router.back();
    },

    renderMember(obj) {
      return obj.staffName;
    },
    //打印取消
    printCancel() {
      this.showPrint = true;
      console.log('取消打印');
    },

    getPhoneType() {
      const u = navigator.userAgent;
      this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    getMakeCardTimes() {
      const date = this.formList.find(i => i.fieldName == '补卡时间').value;
      const params = {
        date,
        staffId: this.initiator.staffId
      };
      getMakeCardTimes(params).then(res => {
        if (res.data.code === 0) {
          this.makeCardTimes = res.data.data;
        }
      });
    },

    //2023-08-15 fry => 获取审批详情单独抽出
    getApplyInfoFn(params) {
      //提交中
      Toast.loading({
        message: '加载中...',
        duration: 0
      });
      getApplyInfo(params).then(res => {
        if (res.data.code === 0) {
          this.kitValue = res.data.data.kitValue;
          if (this.kitValue === 10) {
            this.formList = res.data.data.fields.filter(item => item.fieldName !== '关联项目');
          } else {
            this.formList = res.data.data.fields;
          }

          this.links = this.flatten(
            res.data.data.links.map(item =>
              item.members.map(i => ({
                ...i,
                userType: item.userType,
                files: i.files || []
              }))
            )
          );
          this.links.forEach(item => {
            if (item.files.length > 0) {
              this.showApprovalFileList = true;
            }
          });
          this.fileList = res.data.data.fields.filter(item => item.fieldType === 'upload');
          this.initiator = res.data.data.initiator;
          this.currentApprover = res.data.data.currentApprover;

          this.finalStatus = res.data.data.finalStatus;
          this.copyLink = res.data.data.copyLink;

          this.modelName = res.data.data.modelName;
          this.approvalNo = res.data.data.approvalNo;
          this.oldInstanceId = res.data.data.oldInstanceId || '';

          this.$store.commit('setApproveInfo', res.data.data);

          this.showFinalStatus();
          if (this.kitValue === 1) {
            this.getMakeCardTimes();
          } else {
            this.makeCardTimes = '';
          }

          //提交成功清除loading
          Toast.clear();
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },

    // 转发事件
    async wantWx() {
      if (this.pdfLoading) return;

      this.pdfFile = null;
      this.pdfLoading = true;

      await htmlToPdf.getPdf('abcd', '.record_container', this);

      this.afterPDFRead(this.pdfFile);
    },
    // pdf上传拿到url
    afterPDFRead(file) {
      if (!file) return;
      let filename = `${this.initiator.staffName}提出的${this.modelName}`;

      let content = htmlToPdf.base64toFile(file, filename);
      let formData = new FormData();
      formData.append('file', content);

      let attachment = this.fileList[0]?.value || []; // 附件

      upload(formData)
        .then(res => {
          this.pdfLoading = false;
          let pdfUrl = res.data?.data?.url;

          if (this.isAndroid) {
            let ja = JSON.stringify(attachment); // 安卓接收字符串
            window.androidPrint.print(filename, pdfUrl, ja);
          } else {
            window.webkit.messageHandlers.iosShareWx.postMessage({ filename: filename, pdfUrl: pdfUrl, attachment: attachment });
          }
        })
        .catch(err => {
          this.pdfLoading = false;
        });
    },

    handleFieldName(itm) {
      return itm.fieldName;
    }
  },
  computed: {
    ...mapState(['initialData'])
  },
  created() {
    if (this.$route.query?.instanceId) {
      this.$store.commit('setInitialData', {
        instanceId: this.$route.query?.instanceId
      });
    }
    window.printCancel = this.printCancel;

    const params = {
      companyId: this.initialData.companyId,
      instanceId: this.initialData.instanceId,
      draftFlag: 1
    };

    this.getApplyInfoFn(params);
    this.getPhoneType();
  }
};
</script>

<style scoped>
.record_container {
  width: 100vw;
  min-height: 100vh;
  padding-bottom: 10vh;
  padding-top: 1.71rem;
  position: relative;
  overflow: auto;
  background: #f9f9f9;
}
.info_tab {
  width: 100vw;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}
.info_tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.info_container {
  width: 100vw;
  height: 1.89rem;
  background: #ffffff;
  padding: 0.37rem;
  border-top: 1px solid #f3f3f3;
  box-shadow: 0px 2px 4px 0px #f2f3f5;
}
.info_submit1 {
  font-size: 0.45rem;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  color: #333333;
  line-height: 0.64rem;
  margin-bottom: 0.13rem;
  display: flex;
  justify-content: space-between;
}
.info_submit2 {
  font-size: 0.37rem;
  font-family: SourceHanSansCN, SourceHanSansCN-Regular;
  font-weight: 400;
  color: #ffba18;
  line-height: 0.37rem;
}
.approve_info div {
  margin-bottom: 0.2rem;
}
.approve_info {
  width: calc(100vw - 0.75rem);
  margin: 0.53rem auto;
  padding: 0.43rem;
  padding-bottom: 0.2rem;
  background: #ffffff;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  border-radius: 0.21rem;
  font-size: 0.37rem;
}
.approve_company {
  width: calc(100vw - 0.75rem);
  margin: 0.3rem auto;
  padding: 0.2rem 0.43rem;
  background: #ffffff;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  border-radius: 0.21rem;
  font-size: 0.37rem;
}
.process_start {
  /* display: flex; */
  /* height: 80px; */
  /* justify-content: space-between; */
  padding: 4px 0;
  position: relative;
}

.process_arrow {
  width: 36px;
  display: inline;
  padding: 4px 16px;
  min-height: 1rem;
  /* position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 45px;
  left: 16px; */
}
.approve-content {
  /* position: absolute;
  display: flex;
  flex-direction: column; */
  display: inline;
  width: 7.2rem;
  word-break: break-all;
  /* top: 45px;
  left: 47px;
  width: 73vw; */
  background: #efefef;
  border-radius: 6px;
  padding: 8px;
  margin-left: 0.2rem;
  font-size: 14px;
}
.process_arrow :first-child {
  width: 2px;
  height: 100%;
  margin-left: 2px;
  background: #00ca7b;
}
.process_arrow :last-child {
  width: 0;
  height: 0;
  border-right: 3px solid transparent;
  border-left: 3px solid transparent;
  border-top: 4px solid #00ca7b;
}
.process_info {
  width: calc(100vw - 0.75rem);
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px #f2f3f5;
  padding: 0.43rem;
  margin: 0 auto;
  margin-bottom: 0.43rem;
  padding-bottom: 0;
}
.cclist {
  width: calc(100vw - 0.75rem);
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px #f2f3f5;
  padding: 0.43rem;
  padding-right: 0;
  margin: 0 auto;
  margin-bottom: 0.43rem;
}

.member-img {
  width: 1rem;
  height: 1rem;
  border-radius: 4px;
}

.annex_box {
  width: calc(100vw - 0.75rem);
  margin: 0 auto;
  margin-bottom: 0.43rem;
  padding: 0.43rem;
  background: #ffffff;
  border-radius: 0.21rem;
  box-shadow: 0rem 0rem 0rem 0rem #f2f3f5;
}
.annex_button {
  width: 1.41rem;
  background: #ffffff;
  border-radius: 0.11rem;
  border: 0.03rem solid #1584ff;
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1584ff;
  text-align: center;
  line-height: 0.7rem;
  height: 0.7rem;
  margin-right: 0.1rem;
}
.annex_name {
  display: flex;
  align-items: center;
}

.approve_status {
  width: 1.3rem;
  /* height: 0.5rem; */
  border-radius: 4px;
  font-size: 10px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: center;
  line-height: 0.5rem;
  margin-left: 10px;
}

.selected-member {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1rem;
  position: relative;
  margin-right: 0.2rem;
  margin-bottom: 0.3rem;
}
.member_img {
  width: 40px;
  height: 40px;
  margin-right: 8px;
  border-radius: 0.21rem;
}

.info_field {
  font-size: 0.37rem;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: #333333;
  margin-right: 0.15rem;
}
.info_text {
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 0.37rem;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #555555;
  line-height: 0.67rem;
}

.van-cell /deep/ .van-field__body {
  height: 100%;
}
.van-cell /deep/ .van-field__control {
  height: 100%;
}
.van-cell /deep/ .van-field__label {
  width: auto !important;
  color: #333;
  font-size: 16px;
  font-weight: 500;
}
.van-cell /deep/ .van-field__control--custom {
  display: flex;
  justify-content: flex-end;
}

.zf {
  padding-left: 2px;
  vertical-align: middle;
}
</style>
